import { useEffect, useRef } from "react";
import gsap from "gsap";

const tickerItems = [
  "Available for projects",
  "hello@studio.com",
  "Design & Development",
  "Based worldwide",
  "Let's collaborate",
  "Software Engineering",
];

function TickerContent() {
  return (
    <>
      {tickerItems.map((item, i) => (
        <span key={i} className="flex items-center gap-8 shrink-0">
          <span className="font-serif text-2xl md:text-4xl font-bold whitespace-nowrap">
            {item}
          </span>
          <span className="text-ink/30 text-lg">✦</span>
        </span>
      ))}
    </>
  );
}

export default function Footer() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const contentWidth = track.scrollWidth / 2;

    gsap.set(track, { willChange: "transform" });
    gsap.to(track, {
      x: -contentWidth,
      duration: 30,
      ease: "none",
      repeat: -1,
    });
  }, []);

  return (
    <footer className="border-t border-ink/10">
      {/* Marquee */}
      <div className="py-6 md:py-8 overflow-hidden" data-cursor-hover>
        <div ref={trackRef} className="flex gap-8 will-change-transform">
          <TickerContent />
          <TickerContent />
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-ink/10 px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <span className="font-mono text-xs tracking-widest uppercase text-ink/40">
          © 2025 Sourcebench Labs
        </span>
        <div className="flex gap-6">
          {["Twitter", "Instagram", "Dribbble"].map((link) => (
            <a
              key={link}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="font-mono text-xs tracking-widest uppercase text-ink/40 hover:text-ink transition-colors duration-300 no-underline"
            >
              {link}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
